import {GET, POST} from "@/services/gateway";
import {trimString} from "@/components/common/utils/trimString";

const listGroupMail = ({teamIds, folderId, snapshotDateTime, pagination, searchTerm}) => {
  return POST('recovery/team/groupmail/search', {
    teamIds,
    folderId,
    snapshotDateTime,
    pagination,
    searchTerm: trimString(searchTerm)
  })
}

const listBreadcrumps = ({teamId, folderId, snapshotDate}) => {
  return POST('recovery/team/groupmail/breadcrumbs', {teamId, folderId, snapshotDate})
}

const exportSnapshot = ({snapshotDateTime, sourceIds, searchTerm, selectedIds, outputFormat, code}) => {
  return POST('recovery/team/groupmail/export', {
    snapshotDateTime,
    sourceIds,
    searchTerm: trimString(searchTerm),
    selectedIds,
    outputFormat
  }, {code: code ? code : null})
}

const restoreSnapshot = ({
                           snapshotDateTime,
                           sourceIds,
                           searchTerm,
                           destinationId,
                           snapshotId,
                           selectedIds,
                           RestoreType,
                           code
                         }) => {
  return POST('recovery/team/groupmail/restore', {
    snapshotDateTime,
    sourceIds,
    searchTerm: trimString(searchTerm),
    destinationId,
    snapshotId,
    selectedIds,
    RestoreType
  }, {code: code ? code : null})
}

const getEmailDetails = (id) => {
  return GET(`recovery/team/groupmail/view?postid=${id}`,)
}

export {
  listGroupMail,
  listBreadcrumps,
  exportSnapshot,
  restoreSnapshot,
  getEmailDetails,
}
